{
  "familyId": "SWW-TT-INV-TRICK",
  "questions": [
    {
      "id": "SWW-TT-INV-TRICK-001",
      "familyId": "SWW-TT-INV-TRICK",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_complex",
      "questionType": "multiple_choice",
      "question": "Welke spelling is juist? '... jij ook mee naar het feest?'",
      "options": ["Ga", "Gaat", "Gaan", "Ging"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Inversie: werkwoord eerst", "content": "Inversie betekent: het werkwoord staat vóór het onderwerp (in een vraag). Bv. 'Jij gaat' wordt 'Ga jij?'. Dan valt bij jij/je de -t weg: 'Ga jij?' (stam, zonder -t). Let op: dit geldt ALLEEN bij jij/je. Bij 'Gaat hij?' blijft de -t staan.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "dt_inversion_rule",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Bij inversie staat 'jij' achter het werkwoord. Dan valt de -t weg: gebruik alleen de stam. De stam van 'gaan' is 'ga'. Dus: 'Ga jij?' (niet 'Gaat jij?'). Let op: dit geldt alleen voor jij/je. Bij hij blijft de -t staan: 'Gaat hij?'. Controleer: draai de zin om — 'Jij gaat' → 'Ga jij?'. Valt de -t weg, dan klopt de inversievorm.",
        "solutionSteps": ["Herken inversie: 'jij' staat achter het werkwoord", "Bij inversie met jij/je valt de -t weg", "De stam van 'gaan' is 'ga'", "Antwoord: Ga jij? (niet: Gaat jij?)", "Check: draai de zin om → 'Jij gaat' → 'Ga jij?' ✓"],
        "distractorExplanations": {
          "0": "Goed! Inversieregel: bij inversie met 'jij' gebruik je de stam zonder -t: Ga jij?",
          "1": "Je dacht waarschijnlijk dat de -t blijft staan. Maar bij inversie met jij valt de -t weg: 'Jij gaat' → 'Ga jij?' Onthoud: draai de zin om — als de -t wegvalt, is het inversie.",
          "2": "Je dacht waarschijnlijk dat het hele werkwoord past. Maar 'gaan' is het hele werkwoord. Bij inversie gebruik je de stam: ga. Onthoud: het hele werkwoord verwarren met de stam is een veelgemaakte fout.",
          "3": "Je dacht waarschijnlijk aan de verleden tijd. Maar 'ging' is verleden tijd. De zin gaat over het heden ('naar het feest'), dus tegenwoordige tijd: ga."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.inversie-t-blijft-staan", "label": "Denkt dat -t blijft bij inversie met jij", "optionIndex": 1 },
          { "id": "sww.heel-ww-ipv-stam", "label": "Gebruikt heel werkwoord i.p.v. stam", "optionIndex": 2 },
          { "id": "sww.vt-ipv-tt", "label": "Kiest verleden tijd in tegenwoordige context", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-TT-INV-TRICK-002",
      "familyId": "SWW-TT-INV-TRICK",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_complex",
      "questionType": "multiple_choice",
      "question": "Welke spelling is juist? '... jij morgen ook naar de training?'",
      "options": ["Kom", "Komt", "Komen", "Kwam"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Inversie met jij", "content": "Bij inversie met jij/je valt de -t weg. 'Jij komt' → 'Kom jij?' De stam van 'komen' is 'kom'.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "dt_inversion_komen",
      "variantIndex": 2,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Bij inversie met 'jij' valt de -t weg. Normaal: 'Jij komt'. Bij inversie: 'Kom jij?' De stam van 'komen' is 'kom'. Controleer: draai de zin om → 'Jij komt morgen ook naar de training' → 'Kom jij morgen ook naar de training?'",
        "solutionSteps": ["Herken inversie: 'jij' staat achter het werkwoord", "Normaal: 'Jij komt' (stam + t)", "Inversie: -t valt weg → 'Kom jij?'", "Controleer: 'Jij komt' → 'Kom jij?' ✓"],
        "distractorExplanations": {
          "0": "Goed! Bij inversie met jij valt de -t weg: Kom jij?",
          "1": "Je dacht waarschijnlijk dat de -t blijft staan. Maar bij inversie met jij valt de -t altijd weg: 'Jij komt' → 'Kom jij?' Onthoud: inversie + jij = stam zonder -t.",
          "2": "Je dacht waarschijnlijk dat het hele werkwoord past. Maar 'komen' is het hele werkwoord, niet de vervoegde vorm. Bij inversie gebruik je de stam: kom. Onthoud: stam ≠ heel werkwoord.",
          "3": "Je dacht waarschijnlijk aan de verleden tijd. Maar 'kwam' is verleden tijd. De zin gaat over morgen (tegenwoordige tijd voor toekomst): kom."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.inversie-t-blijft-staan", "label": "Denkt dat -t blijft bij inversie met jij", "optionIndex": 1 },
          { "id": "sww.heel-ww-ipv-stam", "label": "Gebruikt heel werkwoord i.p.v. stam", "optionIndex": 2 },
          { "id": "sww.vt-ipv-tt", "label": "Kiest verleden tijd in tegenwoordige context", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-TT-INV-TRICK-003",
      "familyId": "SWW-TT-INV-TRICK",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_complex",
      "questionType": "multiple_choice",
      "question": "Welke zin is correct gespeld?",
      "options": ["Word jij ook uitgenodigd?", "Wordt jij ook uitgenodigd?", "Worden jij ook uitgenodigd?", "Werd jij ook uitgenodigd?"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Inversie bij d-stam", "content": "De stam van 'worden' is 'word' (eindigt op -d). Bij inversie met jij valt de -t weg: 'Jij wordt' → 'Word jij?' Let op: de -d van de stam blijft staan!", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "dt_inversion_d_stem",
      "variantIndex": 3,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "De stam van 'worden' is 'word' (eindigt op -d). Normaal: 'Jij wordt' (stam + t). Bij inversie valt de -t weg: 'Word jij?' De -d van de stam blijft staan! Dit is een lastige: 'word' ziet er misschien vreemd uit, maar het is correct.",
        "solutionSteps": ["Stam bepalen: worden → word (eindigt op -d)", "Normaal: 'Jij wordt' (word + t = wordt)", "Inversie: -t valt weg → 'Word jij?'", "Let op: de -d van de stam blijft!"],
        "distractorExplanations": {
          "0": "Goed! Bij inversie met jij valt de -t weg: 'Jij wordt' → 'Word jij?' De -d van de stam blijft.",
          "1": "Je dacht waarschijnlijk dat 'wordt' blijft staan bij inversie. Maar bij inversie met jij valt de -t altijd weg: 'wordt' → 'word'. Onthoud: de -t van de uitgang verdwijnt, de -d van de stam blijft.",
          "2": "Je dacht waarschijnlijk dat het hele werkwoord past. Maar 'worden' is het hele werkwoord. Bij inversie gebruik je de stam: word. Onthoud: stam ≠ heel werkwoord.",
          "3": "Je dacht waarschijnlijk aan de verleden tijd. Maar 'werd' is verleden tijd. De vraag gaat over het heden: 'Word jij ook uitgenodigd?'"
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.inversie-d-stam-t-blijft", "label": "Houdt -t vast bij d-stam in inversie", "optionIndex": 1 },
          { "id": "sww.heel-ww-ipv-stam", "label": "Gebruikt heel werkwoord i.p.v. stam", "optionIndex": 2 },
          { "id": "sww.vt-ipv-tt", "label": "Kiest verleden tijd in tegenwoordige context", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-TT-INV-TRICK-004",
      "familyId": "SWW-TT-INV-TRICK",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_complex",
      "questionType": "fill_in",
      "question": "Vul het werkwoord 'vinden' correct in: '... je dat een goed idee?'",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["Vind", "vind"],
        "caseSensitive": false,
        "placeholder": "Typ het werkwoord..."
      },
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Inversie bij d-stam", "content": "De stam van 'vinden' is 'vind' (eindigt op -d). Normaal: 'Je vindt'. Bij inversie valt de -t weg: 'Vind je?' De -d van de stam blijft!", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "dt_inversion_fill_in",
      "variantIndex": 4,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "De stam van 'vinden' is 'vind' (eindigt op -d). Normaal: 'Je vindt' (vind + t = vindt). Bij inversie staat 'je' achter het werkwoord en valt de -t weg: 'Vind je dat een goed idee?' De -d van de stam blijft staan! Controleer: draai de zin terug → 'Je vindt dat een goed idee' → klopt, want vind + t = vindt. Bij inversie valt alleen de -t van de uitgang weg, nooit de -d van de stam.",
        "solutionSteps": ["Stam bepalen: vinden → vind (eindigt op -d)", "Herken inversie: 'je' staat achter het werkwoord", "Bij inversie valt de -t weg: vindt → vind", "Antwoord: Vind je?", "Controleer: draai om → 'Je vindt' (vind + t) → klopt ✓"]
      },
      "pedagogy": {
        "dok": 3
      }
    },
    {
      "id": "SWW-TT-INV-TRICK-005",
      "familyId": "SWW-TT-INV-TRICK",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_complex",
      "questionType": "multiple_choice",
      "question": "Bij welke zin is de inversieregel NIET van toepassing?",
      "options": ["Morgen gaat hij naar school.", "Lees jij dat boek?", "Kom je ook?", "Vind je dat leuk?"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Wanneer geldt inversie?", "content": "De inversieregel (t valt weg) geldt ALLEEN bij jij/je. Bij hij/zij/het blijft de -t staan. 'Gaat hij' → -t blijft. 'Ga jij' → -t valt weg.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "dt_inversion_not_applicable",
      "variantIndex": 5,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "De inversieregel (de -t valt weg) geldt alleen bij jij/je. Bij 'Morgen gaat hij naar school' staat 'hij' achter het werkwoord — maar hij is NIET jij, dus de -t blijft staan: 'gaat hij'. Bij de andere drie zinnen staat jij/je achter het werkwoord en valt de -t wél weg. Vuistregel: alleen bij jij/je achter het werkwoord verdwijnt de -t.",
        "solutionSteps": ["Lees elke zin: wie staat er achter het werkwoord?", "'Gaat hij' → hij → inversieregel geldt NIET", "'Lees jij', 'Kom je', 'Vind je' → jij/je → inversieregel geldt wél", "Alleen bij 'gaat hij' blijft de -t staan → dat is het antwoord ✓"],
        "distractorExplanations": {
          "0": "Goed! Bij 'gaat hij' geldt de inversieregel niet — die geldt alleen bij jij/je, niet bij hij.",
          "1": "'Jij' staat achter het werkwoord → inversie. 'Jij leest' → 'Lees jij?' (-t valt weg). Onthoud: jij achter werkwoord = inversie.",
          "2": "'Je' staat achter het werkwoord → inversie. 'Je komt' → 'Kom je?' (-t valt weg). Onthoud: je = jij.",
          "3": "'Je' staat achter het werkwoord → inversie. 'Je vindt' → 'Vind je?' (-t valt weg, -d blijft)."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.inversie-overgeneraliseren-jij", "label": "Past inversieregel toe op hij/zij/het", "optionIndex": 1 },
          { "id": "sww.inversie-overgeneraliseren-jij", "label": "Past inversieregel toe op hij/zij/het", "optionIndex": 2 },
          { "id": "sww.inversie-overgeneraliseren-jij", "label": "Past inversieregel toe op hij/zij/het", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-TT-INV-TRICK-006",
      "familyId": "SWW-TT-INV-TRICK",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_complex",
      "questionType": "error_spotting",
      "question": "Vind de werkwoordfouten in deze tekst over inversie met jij/je.",
      "correctAnswer": 0,
      "data": {
        "text": "Vindt jij dat een goed idee? Loopt jij vandaag ook hard? Heeft jij dat boek al gelezen?",
        "errors": [
          { "word": "Vindt", "position": 0, "correction": "Vind", "explanation": "Inversie + jij: -t valt weg. De -d van de stam blijft staan: Vind jij." },
          { "word": "Loopt", "position": 6, "correction": "Loop", "explanation": "Inversie + jij: -t valt weg: Loop jij." },
          { "word": "Heeft", "position": 11, "correction": "Heb", "explanation": "Hebben is onregelmatig. Bij inversie met jij: 'Heb jij' (niet Heeft jij)." }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Check elk werkwoord", "content": "Staat jij of je achter het werkwoord? Dan valt de -t van de uitgang weg. De stam-d (vind, word) blijft wel staan. Onregelmatig: hebben wordt 'heb jij'.", "icon": "lightbulb" } }
      ],
      "conceptId": "inversie_error_spotting_check",
      "variantIndex": 6,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Drie fouten met inversie + jij. 'Vindt jij' moet 'Vind jij' zijn (-t valt weg, -d blijft). 'Loopt jij' moet 'Loop jij' zijn (-t valt weg). 'Heeft jij' moet 'Heb jij' zijn (hebben is onregelmatig: jij hebt, dus inversie heb jij). Vuistregel: bij jij/je achter het werkwoord verdwijnt de -t van de uitgang.",
        "solutionSteps": [
          "Lees per zin: staat jij/je achter het werkwoord?",
          "Bij jij/je valt de -t van de uitgang weg",
          "Stam-d/-t blijft wel staan (vind, word)",
          "Onregelmatig: hebben wordt 'heb jij'"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.inversie-t-niet-weg", "label": "T van uitgang behouden bij inversie met jij" },
          { "id": "sww.zijnhebben-correct-als-fout", "label": "Onregelmatig hebben fout vervoegd bij inversie" }
        ]
      }
    },
    {
      "id": "SWW-TT-INV-TRICK-007",
      "familyId": "SWW-TT-INV-TRICK",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_complex",
      "questionType": "matching",
      "question": "Koppel elke zin aan de correcte vorm van het werkwoord bij inversie.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "... jij ook mee? (komen)", "right": "Kom" },
          { "left": "... je dat boek? (lezen)", "right": "Lees" },
          { "left": "... jij volgende week jarig? (worden)", "right": "Word" },
          { "left": "... je deze opdracht? (snappen)", "right": "Snap" },
          { "left": "... jij dat ook leuk? (vinden)", "right": "Vind" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Stam zonder -t", "content": "Bij inversie met jij/je: pak de stam van het werkwoord en plak NIETS toe. Dus 'komen' → 'kom', 'lezen' → 'lees', 'worden' → 'word', 'snappen' → 'snap', 'vinden' → 'vind'.", "icon": "lightbulb" } }
      ],
      "conceptId": "inversie_matching",
      "variantIndex": 7,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Bij inversie met jij/je gebruik je de stam zonder -t. komen → Kom; lezen → Lees; worden → Word (d blijft); snappen → Snap; vinden → Vind (d blijft).",
        "solutionSteps": [
          "Bepaal voor elk werkwoord de stam",
          "Bij inversie met jij/je: gebruik stam zonder -t",
          "Stam-d blijft staan (word, vind), stam-t blijft staan"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SWW-TT-INV-TRICK-008",
      "familyId": "SWW-TT-INV-TRICK",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_complex",
      "questionType": "error_spotting",
      "question": "Vind de werkwoordfouten in deze tekst.",
      "correctAnswer": 0,
      "data": {
        "text": "Wordt jij ook lid van de club? Vindt je dat een goed idee? Mijn broer gaat al, en ik denk dat het leuk is.",
        "errors": [
          { "word": "Wordt", "position": 0, "correction": "Word", "explanation": "Inversie met jij → -t valt weg: 'Word jij?' (stam-d blijft)." },
          { "word": "Vindt", "position": 7, "correction": "Vind", "explanation": "Inversie met je → -t valt weg: 'Vind je?' (stam-d blijft)." }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Check elk werkwoord", "content": "Staat er jij of je achter? Dan moet de -t weg. Stam-d of stam-t blijft wel staan.", "icon": "lightbulb" } }
      ],
      "conceptId": "inversie_error_spotting",
      "variantIndex": 8,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Twee fouten met d-stammen in inversie: 'Wordt jij' moet 'Word jij' zijn (-t valt weg, -d blijft). 'Vindt je' moet 'Vind je' zijn (-t valt weg, -d blijft). 'Gaat' bij broer (hij) is correct — daar geldt inversieregel niet.",
        "solutionSteps": [
          "Lees elke zin: jij/je of hij/zij/het?",
          "'Wordt jij' → jij → -t weg → 'Word jij'",
          "'Vindt je' → je → -t weg → 'Vind je'",
          "'Mijn broer gaat' → hij → -t blijft → correct"
        ]
      },
      "pedagogy": {
        "dok": 3
      }
    },
    {
      "id": "SWW-TT-INV-TRICK-009",
      "familyId": "SWW-TT-INV-TRICK",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_complex",
      "questionType": "categorize",
      "question": "Sorteer elke zinstart op de juiste vorm.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Stam zonder -t (jij/je)", "Stam + -t (hij/zij/het)"],
        "items": [
          { "text": "Word jij ... (jarig)", "correctCategory": 0 },
          { "text": "Vind je ... (leuk)", "correctCategory": 0 },
          { "text": "Kom jij ... (mee)", "correctCategory": 0 },
          { "text": "Wordt hij ... (jarig)", "correctCategory": 1 },
          { "text": "Vindt zij ... (leuk)", "correctCategory": 1 },
          { "text": "Komt hij ... (mee)", "correctCategory": 1 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Twee regels", "content": "Jij/je achter werkwoord → -t valt weg. Hij/zij/het achter werkwoord → -t blijft staan. Twee verschillende regels voor twee verschillende personen.", "icon": "lightbulb" } }
      ],
      "conceptId": "inversie_categorize",
      "variantIndex": 9,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Bij inversie maakt het uit wie er achter het werkwoord staat. Jij/je → stam zonder -t (Word jij, Vind je, Kom jij). Hij/zij/het → stam + -t (Wordt hij, Vindt zij, Komt hij). De inversieregel geldt alléén voor jij/je.",
        "solutionSteps": [
          "Per zinstart: wie staat na het werkwoord?",
          "Jij/je → stam zonder -t",
          "Hij/zij/het → stam + -t"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SWW-TT-INV-TRICK-010",
      "familyId": "SWW-TT-INV-TRICK",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_complex",
      "questionType": "fill_in",
      "question": "Maak de vraag af. Gebruik het werkwoord 'worden' in de juiste vorm: '... jij dit jaar al 13?'",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["Word", "word"],
        "caseSensitive": false,
        "placeholder": "Typ het werkwoord..."
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Inversie + d-stam", "content": "Stam van 'worden' = 'word'. Inversie met jij → -t valt weg. Antwoord: Word jij?", "icon": "lightbulb" } }
      ],
      "conceptId": "inversie_fill_in_word",
      "variantIndex": 10,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Stam 'word' (eindigt op -d). Inversie met jij → -t valt weg → 'Word jij?' De -d van de stam blijft wel staan. Controleer: 'Jij wordt' → 'Word jij?'",
        "solutionSteps": [
          "Stam bepalen: worden → word",
          "Inversie met jij → -t valt weg",
          "Antwoord: Word"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.inversie-d-stam-t-blijft", "label": "Bij inversie + d-stam -t behouden" },
          { "id": "sww.inversie-t-niet-weg", "label": "Bij inversie de -t niet weggehaald" }
        ]
      }
    }
  ]
}